import React, { useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useIonViewWillEnter, IonLoading } from "@ionic/react";
import { ProductsSearchBarHeader } from "@core/components";
import { ProductsSearchResults } from "../ProductsSearchResults/ProductsSearchResults";
import { useProductSearch } from "../../hooks/useProductSearch";
import { useConfig } from "../../providers/config";
import { SendUserRequestFormFab } from "../SendUserRequestFormFab/SendUserRequestFormFab";
import MaxWidthContainer from "../UI/MaxWidthContainer/MaxWidthContainer";
import PageTitle from "../PageTitle/PageTitle";
import Page from "../../pages/page-layout";
import classNames from "classnames/bind";
import styles from "./ProductsSearchPageLayout.module.scss";
import { useSearchParams } from "../../hooks/useSearchParams";
import PullToRefresh from "../../parhato2/src/entities/pullToRefresh";
import { useTranslation } from "react-i18next";

const cx = classNames.bind(styles);

interface ProductsSearchPageLayoutProps {
  pageTitle: string;
  breadcrumbsTitle: string;
  children: React.ReactNode;
  showTitlePage?: boolean;
  showHeaderDesktop?: boolean;
  showContentFooter?: boolean;
  hideResultsOnMdUp?: boolean;
  hideChildrenOnMdUp?: boolean;
  autofocus?: boolean;
}

interface LocationState {
  isSearchInputFocused: boolean;
}

export const ProductsSearchPageLayout: React.FC<ProductsSearchPageLayoutProps> = ({
  children,
  pageTitle,
  breadcrumbsTitle,
  showHeaderDesktop = true,
  showTitlePage = true,
  showContentFooter = true,
  hideChildrenOnMdUp = true,
  hideResultsOnMdUp = true,
  autofocus = false,
}) => {
  const { t } = useTranslation();
  const config = useConfig();
  const history = useHistory();
  const { get: getSearchParam } = useSearchParams();

  const searchText = getSearchParam("q") || "";
  const searchProps = useProductSearch();

  const handleCancel = () => {
    searchProps.cleanSearch();
    history.goBack();
  };

  const showResults = !searchText.length;

  return (
    <Page>
      <IonLoading isOpen={searchProps.isFetching && !searchProps.isFetched} message={t("Please wait...")} />
      <Page.Header mode="ios">
        <MaxWidthContainer classList="!mb-[max(env(safe-area-inset-bottom),1rem)] ">
          <ProductsSearchBarHeader
            onCancel={handleCancel}
            showBackButton={true}
            onClean={searchProps.cleanSearch}
            autofocus={autofocus}
          />
        </MaxWidthContainer>
      </Page.Header>

      <Page.Content>
        <PullToRefresh />
        {showHeaderDesktop && <Page.HeaderDesktop breadcrumbs={[{ title: breadcrumbsTitle }]} />}
        <div className={`${cx("productsContainer")} global-content`}>
          <MaxWidthContainer breakPoints={true}>
            {showTitlePage && <PageTitle hideTitleBreakpoint="ion-hide-md-down" title={pageTitle} />}
            <div className={cx(hideResultsOnMdUp && "ion-hide-md-up")}>
              {showResults ? children : <ProductsSearchResults />}
            </div>
            <div className={cx(hideChildrenOnMdUp && !showResults ? "hidden" : "ion-hide-md-down")}>{children}</div>
          </MaxWidthContainer>
        </div>
        {config?.showSendCustomerRequestButton && <SendUserRequestFormFab />}
        {showContentFooter && <Page.ContentFooter />}
      </Page.Content>
    </Page>
  );
};
